import { getAxiosClient } from "../../axios-client";
import { GetAllOffersBody, GetAllOffersResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllOffers = async (body: GetAllOffersBody) => {
  return await axiosClient.ax.post<GetAllOffersResponse>(
    "/Offers/GetAllOffers",
    body
  );
};
